/* LOPAZZI — FIX DEFINITIVO IMAGENS PRETAS */
/* Causa: deferred-media nao carrega imagens automaticamente no Horizon */
/* Solucao: forca loadContent() em todos os deferred-media com imagem */

(function() {

  function loadAllDeferredImages() {
    document.querySelectorAll('deferred-media').forEach(function(dm) {

      // Ja foi carregado
      if (dm.hasAttribute('data-media-loaded')) return;

      // Verifica se tem template com imagem (nao video/modelo)
      var template = dm.querySelector('template');
      if (!template) {
        // Sem template - força visibilidade do que ja está lá
        dm.querySelectorAll('img').forEach(function(img) {
          img.style.opacity = '1';
          img.style.visibility = 'visible';
          if (img.dataset.src) { img.src = img.dataset.src; }
          if (img.dataset.srcset) { img.srcset = img.dataset.srcset; }
        });
        return;
      }

      var templateContent = template.content.firstElementChild;
      if (!templateContent) return;

      // Se o template contem video ou iframe, nao auto-carrega
      var tagName = templateContent.tagName ? templateContent.tagName.toLowerCase() : '';
      if (tagName === 'video' || tagName === 'iframe' || tagName === 'model-viewer') return;

      // É uma imagem — carrega imediatamente
      dm.setAttribute('data-media-loaded', 'true');
      var clone = templateContent.cloneNode(true);
      dm.appendChild(clone);

      // Garante visibilidade
      dm.querySelectorAll('img').forEach(function(img) {
        img.style.opacity = '1';
        img.style.visibility = 'visible';
      });
    });

    // Garante todas as imagens visiveis
    document.querySelectorAll(
      '.product-media-container img, product-media-gallery img, .card-gallery img, slideshow-slide img'
    ).forEach(function(img) {
      img.style.opacity = '1';
      img.style.visibility = 'visible';
      if (img.dataset.src) { img.src = img.dataset.src; }
      if (img.dataset.srcset) { img.srcset = img.dataset.srcset; }
    });
  }

  // Executa assim que possivel
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadAllDeferredImages);
  } else {
    loadAllDeferredImages();
  }

  // Executa em varios momentos para pegar imagens lazy
  setTimeout(loadAllDeferredImages, 200);
  setTimeout(loadAllDeferredImages, 600);
  setTimeout(loadAllDeferredImages, 1500);

  // Observa novos elementos adicionados ao DOM
  var observer = new MutationObserver(function(mutations) {
    var hasNewMedia = mutations.some(function(m) {
      return Array.from(m.addedNodes).some(function(n) {
        return n.nodeType === 1 && (
          n.tagName === 'DEFERRED-MEDIA' ||
          (n.querySelector && n.querySelector('deferred-media, slideshow-slide'))
        );
      });
    });
    if (hasNewMedia) setTimeout(loadAllDeferredImages, 100);
  });

  document.addEventListener('DOMContentLoaded', function() {
    observer.observe(document.body, { childList: true, subtree: true });
  });

  // Fix para trocar de variante
  document.addEventListener('click', function(e) {
    if (e.target && e.target.closest && e.target.closest('.variant-option, product-card, slideshow-arrows')) {
      setTimeout(loadAllDeferredImages, 200);
    }
  });

})();